module.exports = __webpack_public_path__ + "static/media/nigeria.45355aa3.svg";